import { render, staticRenderFns } from "./SxsLogin.vue?vue&type=template&id=6de5dee0&scoped=true&"
import script from "./SxsLogin.vue?vue&type=script&lang=js&"
export * from "./SxsLogin.vue?vue&type=script&lang=js&"
import style0 from "./SxsLogin.vue?vue&type=style&index=0&id=6de5dee0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de5dee0",
  null
  
)

export default component.exports